const TopLineLoader: React.FC = () => {
  return (
    <>
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: 6,
          // backgroundColor: "red",
          background:
            "linear-gradient(90deg, red 20%, yellow 40%, #519e03 60%, yellow 80%, red 100%)",
          backgroundSize: "200%",
          animation: "move-gradient 3s linear infinite",
        }}
      ></div>
      <style>{`
        @keyframes move-gradient {
          0% {background-position: 0% 0%}
        100% {background-position: -200% 0%}
        }
      `}</style>
    </>
  );
};

export default TopLineLoader;
